import Cookies from 'js-cookie';
import { EvenementTNR } from '../constants/evenement-tnr.enum';
import { OpinionService } from '@oel/js-opinion';
import { AppConfigService } from '../../app-config.service';
import { Injectable } from '@angular/core';
import { StatusPreautorisation } from '../modeles/variables';
import { ToolPreautorisationService } from '../../tool-preautorisation/tool-preautorisation.service';
import { get } from 'lodash';

@Injectable({
  providedIn: 'any'
})
export class TNRService {
  isApp = false;
  statutPreaut: StatusPreautorisation;

  constructor(
    private readonly _appConfigService: AppConfigService,
    private readonly _toolPreautorisationService: ToolPreautorisationService
  ) {
    this.isApp = this._appConfigService.isApp;
    this._toolPreautorisationService.getStatusPreautorisation$.subscribe(status => (this.statutPreaut = status));
  }

  saveTNREvent(event: EvenementTNR) {
    if (event === EvenementTNR.PREAUT_NON_COMPLETEE) {
      // Seulement creer le cookie si pas de preaut acceptee ou refusee
      // pour ne pas ecraser les cookies preaut completee
      if (
        this.statutPreaut !==
        (StatusPreautorisation.Acceptee &&
          StatusPreautorisation.RefuseeSimplifie &&
          StatusPreautorisation.ContreOffreEnAttente)
      ) {
        this.removeTNRCookie();
        OpinionService.enregistrerEvenementTnr(event, this.isApp);
      }
    } else {
      // Clear les anciens cookies et creer celui pour preaut completee
      this.removeTNRCookie();
      OpinionService.enregistrerEvenementTnr(event, this.isApp);
    }
  }

  removeTNRCookie() {
    Cookies.remove(EvenementTNR.TNR_COOKIE, { path: '/', domain: EvenementTNR.DOMAIN_DESJARDINS_COOKIE });
  }
}
